import type { ChartConfig } from '@/shared/components/ui/chart'
import type { DonutViewDataItem } from './types'

import { useTranslation } from 'react-i18next'
import { Cell, Pie, PieChart } from 'recharts'

import {
	ChartContainer,
	ChartTooltip,
	ChartTooltipContent,
} from '@/shared/components/ui/chart'

import DonutLegend from './DonutLegend'

export type DonutView3Props = {
	data: DonutViewDataItem[]
	total?: number
	formatValue?(value: number): string
	formatSubValue?(value: number): string
}
export default function DonutView3({
	data = [],
	total,
	formatValue,
	formatSubValue,
}: DonutView3Props) {
	const { t } = useTranslation()

	const chartConfig = Object.fromEntries(
		data.map(({ name, color }) => [name, { label: name, color }])
	) satisfies ChartConfig

	return (
		<div className='grid grid-cols-12 gap-2'>
			<div className='col-span-5'>
				<ChartContainer
					config={chartConfig}
					className='aspect-auto h-47 w-full'
				>
					<PieChart startAngle={-90}>
						<ChartTooltip content={<ChartTooltipContent />} />
						<Pie
							data={data}
							dataKey='y'
							nameKey='name'
							innerRadius='60%'
							outerRadius='100%'
							strokeWidth={0}
							isAnimationActive
						>
							{data.map(({ name, color }) => (
								<Cell key={name} fill={color} />
							))}
						</Pie>
					</PieChart>
				</ChartContainer>
			</div>
			<div className='col-span-7 flex items-center'>
				<div className='w-full space-y-2 text-sm'>
					{total !== undefined && (
						<div className='flex items-center justify-between font-semibold'>
							<span className='flex items-center'>
								{t('app.total', { defaultValue: 'Total' })}
							</span>
							<span>{formatValue ? formatValue(total) : total}</span>
						</div>
					)}
					<DonutLegend
						formatValue={formatValue}
						formatSubValue={formatSubValue}
						data={data}
					/>
				</div>
			</div>
		</div>
	)
}
